import { Pipe, PipeTransform } from '@angular/core';
import { EmploymentStatusTypeId } from '../../../models/employers/enum/employment-status-type-id';
import { StatusPill } from '../../../models/shared/status-pill';
import {
  EmploymentHistoryStatusPrimaryPillColors,
  EmploymentHistoryStatusSecondaryPillColors
} from '../../../models/enum/shared/employment-history-status-pill-colors.enum';

@Pipe({
  name: 'employmentStatusPill',
  standalone: true
})
export class EmploymentStatusPillPipe implements PipeTransform {
  transform(statusId: EmploymentStatusTypeId): StatusPill {
    switch (statusId) {
      case EmploymentStatusTypeId.Active:
        return new StatusPill(
          statusId,
          'Active',
          EmploymentHistoryStatusPrimaryPillColors.Active,
          EmploymentHistoryStatusSecondaryPillColors.Active
        );
      case EmploymentStatusTypeId.Inactive:
        return new StatusPill(
          statusId,
          'Inactive',
          EmploymentHistoryStatusPrimaryPillColors.Inactive,
          EmploymentHistoryStatusSecondaryPillColors.Inactive
        );
      case EmploymentStatusTypeId.Leave:
        return new StatusPill(
          statusId,
          'On Leave',
          EmploymentHistoryStatusPrimaryPillColors.Leave,
          EmploymentHistoryStatusSecondaryPillColors.Leave
        );
    }
  }
}
